import React from "react"
import {getSearchValue} from "../../helpers"

export type SDT = React.Dispatch<React.SetStateAction<SearchState>>

export class SearchApi {
  setState: SDT;
  setIsEnabled: (isEnabled: boolean) => void;
  getValue: () => string;
  setValue: (value: string) => void;
  resetValue: () => void;
  constructor(api: Partial<SearchApi>) {
    this.setState = api.setState ?? (() => "")
    this.setIsEnabled = api.setIsEnabled ?? (() => "")
    this.getValue = api.getValue ?? (() => "")
    this.setValue = api.setValue ?? (() => "")
    this.resetValue = api.resetValue ?? (() => "")
  }
}
export class SearchState {
  value: string = "";
  constructor() {
    this.value = getSearchValue() || ""
  }
}
